import Api from "~/service/Api";

class Immersive3dTourUploadedPanoramaCheckRepository {
  fetchOne(query) {
    return Api.get("/immersive-3d-tour/uploaded-panorama-checks", query);
  }
}

export default Immersive3dTourUploadedPanoramaCheckRepository;
